import { render } from "./create_client.vue?vue&type=template&id=19d0ce9a&scoped=true"
import script from "./create_client.vue?vue&type=script&lang=js"
export * from "./create_client.vue?vue&type=script&lang=js"

import "./create_client.vue?vue&type=style&index=0&id=19d0ce9a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d0ce9a"]])

export default __exports__